module.exports = __webpack_public_path__ + "static/media/icon-checked.88dc5d5e.svg";